//import { useState, useEffect } from "react";

//const ANIMALS = ["bird", "cat", "dog", "rabbit", "reptile"];

const Module1 = () => {
  return (
    <div className="module1">
      <h2>Free dome plans for all.</h2>
    </div>
  );
};

export default Module1;
